module.exports = __webpack_public_path__ + "assets/honeywellsanstt-book-19c6d2.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./Content/fonts/honeywellsanstt-book.ttf
 ** module id = 943
 ** module chunks = 2
 **/